<template lang='pug'>
  v-snackbar(bottom center :timeout='duration' v-model='showSnackbar')
    span.text-body-1(v-html='message')
    template(v-slot:action='{attrs}')
      v-btn(icon x-small dark v-bind='attrs', @click='close')
        v-icon close
</template>

<script>
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsSnackbar',
  components: {},
  methods: {
    toast(message) {
      this.message = message;
      this.showSnackbar = true;
    },
    close() {
      this.showSnackbar = false;
    }
  },
  mounted() {
    Notifications.setToaster(this.toast);
  },
  data() {
    return {
      message: null,
      showSnackbar: false,
      duration: 4000
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
